import { Link, useParams, useLocation } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { AlertMessage } from "app/components/AlertMessage";
import { Loading } from "app/components/Loading";
import moment from "moment";
import Api, { createFetchErrorMessage } from "utils/api/Api";

export const UserBookEpisodeList = ({book})=>{
    const location = useLocation();
    const { school } = useParams();
    const { data:episodeList,  isLoading, isError, error } = useQuery({
        queryKey:['userbook/episode/list', book],
        queryFn:()=>Api.get(`/api/userBook/episode/list?bookId=${book}`),
    });


    
    if ( isError )return <div className="no_data">{createFetchErrorMessage(error).message}</div>;
    if ( episodeList?.data?.length<=0)return <div className="no_data">등록된 회차가 없습니다.</div>;
    
    const now = moment();
    const episodeCount = episodeList?.data?.length;

    return (
        <div className="inner">
            <div className="episodeListContainer">
                <div className="subTitle">
                    <div className="listCount">순서</div>
                    <div className="title">제목</div>
                    <div className="info">
                        <div className="date">날짜</div>
                        <div className="hitsCount">조회수</div>
                        <div className="likeConut">좋아요</div>
                    </div>
                </div>
                <ul className="episodeList listContainer">
                    { isLoading && <Loading />}
                    {
                        episodeList?.data?.map((episode, key)=>{
                            const createdAt = moment(episode.createdAt);
                            return (
                                <div key={episode.id} className="episode">
                                    <Link className={`${episode.deleteYn === "Y" ? "deleteContainer" : ""}`} to={`/${school}/userbook/episode/view/${episode.id}${location.search}`}>
                                        <div className="listCount">{episodeCount-key}</div>
                                        <div className="title">
                                            { episode.deleteYn==='Y' && <AlertMessage type="delete" text="삭제됨" visible={episode.deleteYn === "Y"} /> }
                                            
                                            { now.diff(createdAt, 'days')<1 && <label className="label red">UP</label> }
                                            <p>{episode.subject}</p>
                                            {episode.commentCount>0 && <span className="commentCount"><i className="fas fa-comment-dots"></i> {episode.commentCount}</span> }
                                        </div>
                                        <div className="info">
                                            <div className="updateAt"> {createdAt.format('YYYY년 M월 DD일')} </div>
                                            <div className="hitsCount"><i className="far fa-eye"></i> {episode.readCount}</div>
                                            <div className="likeCount"><i className="far fa-heart"></i> {episode.likeCount}</div>
                                        </div>
                                    </Link>
                                </div>
                            );
                        })
                    }
                </ul>
            </div>
        </div>
    );
};